(function(w) {
    w.ag_f_l = [];
    w.ag_f_c_en = [];
    w.ag_f_c_fr = [];
    w.ag_f_c_ja = [];
    w.ag_f_bc = [];
    w.ag_f_p = [];
    w.ag_f_ft = [];
    w.ag_f_pt = [];
    class ag_form_array_constructor {
        constructor(l, j) {
            this.lang = l;
            this.t_json = j;
        }
    };
    w.add_ag_form_label = function(l, j) {
        var ag_f_t = new ag_form_array_constructor(l, j);
        w.ag_f_l.push(ag_f_t);
    };
    w.add_ag_form_country_en = function(j) {
        w.ag_f_c_en.push(j);
    };
    w.add_ag_form_country_fr = function(j) {
        w.ag_f_c_fr.push(j);
    };
    w.add_ag_form_country_ja = function(j) {
        w.ag_f_c_ja.push(j);
    };
    w.add_ag_form_continue = function(l, j) {
        var ag_f_bc = new ag_form_array_constructor(l, j);
        w.ag_f_bc.push(ag_f_bc);
    };
    w.add_ag_form_paragraph = function(l, j) {
        var ag_f_p = new ag_form_array_constructor(l, j);
        w.ag_f_p.push(ag_f_p);
    };
    w.add_ag_form_footer_text = function(l, j) {
        var ag_f_ft = new ag_form_array_constructor(l, j);
        w.ag_f_ft.push(ag_f_ft);
    };
    w.add_ag_form_prohibited_text = function(l, j) {
        var ag_f_pt = new ag_form_array_constructor(l, j);
        w.ag_f_pt.push(ag_f_pt);
    };
})(window);
